/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingSearchExperienceLevel = {
    Entry: 'ENTRY',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT',
    ExpertPlus: 'EXPERT_PLUS'
} as const;
export type SourcingSearchExperienceLevel = typeof SourcingSearchExperienceLevel[keyof typeof SourcingSearchExperienceLevel];


export function instanceOfSourcingSearchExperienceLevel(value: any): boolean {
    for (const key in SourcingSearchExperienceLevel) {
        if (Object.prototype.hasOwnProperty.call(SourcingSearchExperienceLevel, key)) {
            // @ts-ignore
            if (SourcingSearchExperienceLevel[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingSearchExperienceLevelFromJSON(json: any): SourcingSearchExperienceLevel {
    return SourcingSearchExperienceLevelFromJSONTyped(json, false);
}

export function SourcingSearchExperienceLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchExperienceLevel {
    return json as SourcingSearchExperienceLevel;
}

export function SourcingSearchExperienceLevelToJSON(value?: SourcingSearchExperienceLevel | null): any {
    return value as any;
}

